import React, { Suspense } from 'react';

import { TradingType } from 'common/api/autogenerated/client-area';

import { usePopup } from 'common/hooks';
import { ModalAction } from 'common/redux/modal/initialState';

import './index.css';

const TransferContainer = React.lazy(
  () => import(/* webpackChunkName: "TransferContainer" */ 'views/transfer/Transfer.container'),
);

type Props = {
  currency?: string;
  fromType?: TradingType;
  toType?: TradingType;
};

type TransferPopupProps = ModalAction & Props;

const TransferPopup: React.FC<React.PropsWithChildren<Props>> = ({ currency, fromType, toType }) => {
  const { hide } = usePopup();

  return (
    <div data-test='transfer-popup' className='transfer-popup'>
      <Suspense>
        <TransferContainer onComplete={hide} currency={currency} fromType={fromType} toType={toType} />
      </Suspense>
    </div>
  );
};

export default (props: TransferPopupProps) => ({
  component: <TransferPopup currency={props.currency} fromType={props.fromType} toType={props.toType} />,
  wrapperClassName: 'transfer-popup-wrapper',
  hideCloseIcon: false,
  ...props,
});
